import { render, staticRenderFns } from "./2021-1-1-code.vue?vue&type=template&id=4df82b6a&scoped=true&"
import script from "./2021-1-1-code.vue?vue&type=script&lang=ts&"
export * from "./2021-1-1-code.vue?vue&type=script&lang=ts&"
import style0 from "./2021-1-1-code.vue?vue&type=style&index=0&id=4df82b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df82b6a",
  null
  
)

export default component.exports